import { WalletResponse, WalletState } from '../models'

/**
 * SET INITIAL VALUES - WALLET
 */
export const initialWallet: WalletResponse = {
  id: 0,
  playerId: 0,
  username: '',
  bonusName: '',
  bonusCode: '',
  bonusAmount: 0,
  depositAmount: 0,
  winningsAmount: 0,
  bonusCancelled: 0,
  grantedAmount: 0,
  grantedDeposit: 0,
  rolloverAmount: 0,
  rolloverGranted: 0,
  rollover: 0,
  rolloverCoefficcient: 0,
  deposiId: 0,
  status: '',
  walletType: 0,
  createdAt: '',
}

/**
 * SET WALLET INITIAL STATE
 */
const initialState: WalletState = {
  isLoading: false,
  hasError: false,
  error: '',
  wasDeleted: false,
  currentWallet: initialWallet,
  wallets: [],
  pagination: {
    total: 0,
    limit: 25,
    page: 1,
    pages: 1,
  },
  filters: {
    page: 1,
    limit: 25,
    status: ['1'],
  },
  freePlaysCalculated: null,
}

export default initialState
